import React, { Fragment } from "react";
import { Tab, Tabs } from "react-bootstrap";

function UiNavTabs(props) {
    return (

        <Tabs defaultActiveKey={props.defaultActiveKey} onSelect={props.onSelect}
              id="uncontrolled-tab-example" className="mb-3" {...props} />

    );
}

function UiNavTab(props) {
    return (
        <Fragment>
            <Tab eventKey={props.eventKey} title={props.title} {...props} />
        </Fragment>
    );
}

export { UiNavTabs, UiNavTab };